interface RegistryInformationProps {
  information: string;
  className?: string;
}

export const RegistryInformation = ({ information, className }: RegistryInformationProps) => {
  return (
    <div className={`rounded-lg bg-white shadow-md ${className}`}>
      <h3 className="p-4 text-lg font-medium">Registry Information</h3>
      <div className="h-[0.5px] w-full bg-gray-300"></div>
      <p className="p-4 text-sm">{information}</p>
    </div>
  );
};
